import { render, staticRenderFns } from "./SidebarNavProfile.vue?vue&type=template&id=1011d8a3"
import script from "./SidebarNavProfile.vue?vue&type=script&lang=js"
export * from "./SidebarNavProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports